export interface FaqItem {
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    question: 'How will I receive the material?',
    answer:
      'Immediately after payment, you’ll receive instructions to access the Occlusion 360™ system and download the included digital materials.',
  },
  {
    question: 'What format is the material in?',
    answer:
      'The system is delivered digitally and includes the 6 volumes, visual maps, checklists, analysis tools, case studies, and bonuses.',
  },
  {
    question: 'How long will I have access?',
    answer: 'You’ll have 1 year of access to the complete system.',
  },
  {
    question: 'Is Occlusion 360™ for specialists only?',
    answer:
      'No. It is designed as educational support material for dental professionals who work with or study occlusion, restorative dentistry, and rehabilitation cases.',
  },
  {
    question: 'Do I need advanced occlusion knowledge?',
    answer:
      'The system is designed to organize concepts and clinical reasoning in a structured way. It does not replace professional education, clinical training, diagnosis, or professional judgment.',
  },
  {
    question: 'Does the system replace clinical diagnosis?',
    answer:
      'No. Occlusion 360™ is an educational decision-support resource. Clinical decisions must always be based on the individual patient’s evaluation, appropriate professional training, and the dentist’s clinical judgment.',
  },
  {
    question: 'Is this a one-time payment?',
    answer: 'Yes. You pay $27 USD once. There are no monthly fees.',
  },
  {
    question: 'What if I don’t like it?',
    answer:
      'You have a 7-day money-back guarantee. If you decide that the material isn’t right for you, you can request a refund during the guarantee period.',
  },
]
